import adminApi from '../utils/adminRequest';

class AdminResumeTemplatesStatsApi {
    getStats() {
        return adminApi.get('/api/v1/admin/resume-templates/stats');
    }
}

export default new AdminResumeTemplatesStatsApi();

